import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BlockTemplateType } from '../../models/block-template.model';
import { DefaultDataBlockItem } from '../data-blocks-items/default-data-item-block/default-data-item-block';
import { HeartRateDataBlockItem } from '../data-blocks-items/heart-rate-data-block/heart-rate-data-block-item';
import { HeartRateZoneDataBlockItem } from '../data-blocks-items/heart-rate-zone-data-block-item/heart-rate-zone-data-block-item';
import { SpeedDataBlockItem } from '../data-blocks-items/speed-data-block-item/speed-data-block-item';
import { CaloriesDataBlockItem } from '../data-blocks-items/calories-data-item-block/calories-data-item-block';
import { DistanceDataBlockItem } from '../data-blocks-items/distance-data-item-block/distance-data-item-block';
import { PositiveSlopeDataBlockItem } from '../data-blocks-items/positive-slope-data-item-block/positive-slope-data-item-block';
import { DurationDataBlockItem } from '../data-blocks-items/duration-data-block-item/duration-data-block-item';
import { PaceDataBlockItem } from '../data-blocks-items/pace-data-block-item/pace-data-block-item';
import { ProgressDataBlockItem } from '../data-blocks-items/progress-data-block-item/progress-data-block-item';
import { WebSocketService } from '../../services/websocket-service';
import { SportType } from '../../models/sport.model';

type ScreenDatasLayoutType = 'scenic' | 'coaching';

@Component({
  selector: 'app-screen-datas',
  imports: [
    DefaultDataBlockItem,
    HeartRateDataBlockItem,
    HeartRateZoneDataBlockItem,
    SpeedDataBlockItem,
    CaloriesDataBlockItem,
    DistanceDataBlockItem,
    PositiveSlopeDataBlockItem,
    DurationDataBlockItem,
    PaceDataBlockItem,
    ProgressDataBlockItem,
    TranslateModule,
  ],
  templateUrl: './screen-datas.html',
  styleUrl: './screen-datas.scss',
  host: {
    '[class.coaching]': "layout() === 'coaching'",
  },
})
export class ScreenDatas {
  private readonly webSocketService: WebSocketService = inject(WebSocketService);

  dataBlocks: InputSignal<BlockTemplateType[]> = input.required();
  layout: InputSignal<ScreenDatasLayoutType> = input<ScreenDatasLayoutType>('scenic');

  protected readonly cadenceUnitKey: Signal<string> = computed(() => {
    if (this.layout() !== 'coaching') return 'common.metric.cadence.short';
    const sport: SportType = this.webSocketService.contentInformation()?.sport || 'cycling';
    return `common.metric.cadence.${sport}`;
  });
}
